// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"22e09176","406":"d1d5c88d","496":"0ffe104f","694":"974a145f","848":"9e866a5c"}[chunkId] + ".chunk.js";
};